import useTranslationLgs from '@hooks/i18n/useTranslation';
import { useRuleMetadata } from '../metadata/RuleMetadataProvider';

/** `expedition.status_changed` → `Expedition status changed`, for a trigger metadata has not got. */
const humanize = (key: string): string => key.replace(/[._]/g, ' ').replace(/^./, first => first.toUpperCase());

/**
 * A trigger in words.
 *
 * The key is the backend's (`expedition.created`) and its Locize key comes from `/metadata`, so a
 * trigger added on the backend reads properly here without a frontend release — the same rule the
 * rest of the feature follows. Raw keys are for the rule text, not for a page someone reads.
 *
 * Must be used inside a `RuleMetadataProvider`.
 */
export const useTriggerLabel = () => {
  const { tr } = useTranslationLgs();
  const { triggerByKey } = useRuleMetadata();

  return (key?: string): string | null => {
    if (!key) return null;
    const trigger = triggerByKey(key);
    return trigger ? tr(trigger.i18nKey, humanize(key)) : humanize(key);
  };
};
